var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pageVue.headerBanner
        ? [
            _c("showcase-header-banner", {
              attrs: {
                "background-color": _vm.pageVue.headerBanner.backgroundColor,
                icon: _vm.pageVue.headerBanner.icon,
                label: _vm.pageVue.headerBanner.label,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("section", { attrs: { id: "page-header" } }, [
        _c("div", { staticClass: "container-fluid my-2 my-md-3" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h1", {
                domProps: { innerHTML: _vm._s(_vm.pageVue.pageTitle) },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-md-2 mb-1" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("p", { staticClass: "lead mb-1 p-0" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.pageVue.priceValidityLabel0),
                  },
                }),
                _vm._v(" "),
                _c("span", [
                  _c("a", {
                    attrs: { href: "#mentions" },
                    domProps: {
                      innerHTML: _vm._s(_vm.pageVue.priceValidityLink),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.pageVue.priceValidityLabel1),
                  },
                }),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.pageVue.onBoardingComponent
        ? _c("internet-and-mobile-on-boarding", {
            attrs: {
              "on-boarding-offer-description-text":
                _vm.pageVue.onBoardingComponent.offerDescriptionText,
              "on-boarding-yearly-discounts-info-text":
                _vm.pageVue.onBoardingComponent.yearlyDiscountsInfoText,
              "button-label": _vm.pageVue.onBoardingComponent.buttonLabel,
              "discount-advantages-popin":
                _vm.pageVue.onBoardingComponent.discountAdvantagesPopin,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { attrs: { id: "internet-and-mobile-offers" } },
        [
          _c("eligibility-form", {
            attrs: {
              token: _vm.token,
              "init-eligibility-url": _vm.pageVue.initEligibilityUrl,
              "mobile-offers-model": _vm.pageVue.mobileOffersModel,
              "internet-offers-model": _vm.pageVue.internetOffersModel,
            },
          }),
          _vm._v(" "),
          _vm.pageVue.topEligibilityResult
            ? _c("EligibilityResult", {
                attrs: {
                  "eligibility-result": _vm.pageVue.topEligibilityResult,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "container-fluid mb-3",
              attrs: { id: "recommend-or-compose-pack-navigation" },
            },
            [
              _c(
                "nav",
                {
                  staticClass: "ob1-menu-page ob1-menu-page-fullscreen",
                  staticStyle: { height: "auto !important" },
                },
                [
                  _c("ul", { staticClass: "nav ob1-nav-light" }, [
                    _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        class: { active: _vm.showOnlyRecommendedOffers },
                      },
                      [
                        _c("button", {
                          staticClass: "nav-link px-0",
                          attrs: {
                            "data-oevent-category":
                              _vm.pageVue.tmsButtonPackMoment.category,
                            "data-oevent-action":
                              _vm.pageVue.tmsButtonPackMoment.action,
                            "data-oevent-label":
                              _vm.pageVue.tmsButtonPackMoment.label,
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.pageVue.recommendedPackTabLabel
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeSelectedTab(
                                _vm.hashTagPackDuMoment
                              )
                            },
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        class: { active: !_vm.showOnlyRecommendedOffers },
                      },
                      [
                        _c("button", {
                          staticClass: "nav-link px-0",
                          attrs: {
                            "data-oevent-category":
                              _vm.pageVue.tmsButtonComposerPack.category,
                            "data-oevent-action":
                              _vm.pageVue.tmsButtonComposerPack.action,
                            "data-oevent-label":
                              _vm.pageVue.tmsButtonComposerPack.label,
                          },
                          domProps: {
                            textContent: _vm._s(
                              _vm.pageVue.composePackTabLabel
                            ),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeSelectedTab(
                                _vm.hashTagComposerUnPack
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.showOnlyRecommendedOffers
            ? _c(
                "div",
                [
                  _c("recommended-offers", {
                    attrs: {
                      "internet-offers-model": _vm.pageVue.internetOffersModel,
                      "mobile-offers-model": _vm.pageVue.mobileOffersModel,
                      "mobile-offers-tiles":
                        _vm.pageVue.mobileOffersComponent.mobileOffersTiles,
                      "internet-offers-tiles":
                        _vm.pageVue.internetOffersComponent.internetOffersTiles,
                      "recommended-offers-data":
                        _vm.pageVue.recommendedOffersComponent,
                      "show-eligibility-result": false,
                      "fo-link-query-params": _vm.foLinkQueryParams,
                    },
                  }),
                  _vm._v(" "),
                  _vm.pageVue.recommendedAnimationPush
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "container-fluid px-2 px-lg-1 pb-2 mb-2",
                          },
                          [
                            _c("div", { staticClass: "row py-1" }, [
                              _c(
                                "div",
                                { staticClass: "col-12 pb-1" },
                                [
                                  _c("push-animation", {
                                    attrs: {
                                      "push-animation":
                                        _vm.pageVue.recommendedAnimationPush,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showOnlyRecommendedOffers
            ? _c(
                "div",
                [
                  _c("mobile-offers", {
                    attrs: {
                      "mobile-offers-data": _vm.pageVue.mobileOffersComponent,
                      "mobile-offers-model": _vm.pageVue.mobileOffersModel,
                      "selected-mobile-offer-seo-id":
                        _vm.selectedMobileOfferSeoId,
                      "fo-link-query-params": _vm.foLinkQueryParams,
                    },
                    on: {
                      "select-mobile-offer-seo-id": function ($event) {
                        return _vm.selectMobileOffer($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("internet-offers", {
                    attrs: {
                      "internet-offers-data":
                        _vm.pageVue.internetOffersComponent,
                      "selected-internet-offer-seo-id":
                        _vm.selectedInternetOfferSeoId,
                      "internet-offers-filter": _vm.internetOffersFilter,
                      "detail-page-query-params": _vm.detailPageQueryParams,
                    },
                    on: {
                      "select-internet-offer-seo-id": function ($event) {
                        return _vm.selectInternetOffer($event)
                      },
                      "after-swiper-update": _vm.afterSwiperUpdate,
                      "update-filter-equipment": function ($event) {
                        return _vm.updateFilterEquipment($event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("cart-recap", {
                    attrs: {
                      "cart-recap-data": _vm.pageVue.cartRecapComponent,
                      "mobile-offers-model": _vm.pageVue.mobileOffersModel,
                      "selected-internet-offer-seo-id":
                        _vm.selectedInternetOfferSeoId,
                      "selected-mobile-offer-seo-id":
                        _vm.selectedMobileOfferSeoId,
                      "internet-offers-tiles":
                        _vm.pageVue.internetOffersComponent.internetOffersTiles,
                      "mobile-offers-tiles":
                        _vm.pageVue.mobileOffersComponent.mobileOffersTiles,
                      "new-pack-summaries-by-seo-ids":
                        _vm.pageVue.newPackSummariesBySeoIds,
                      "blocked-mobile-offer-title":
                        _vm.pageVue.cartRecapComponent.blockedMobileOfferTitle,
                      "blocked-mobile-offer-toggle-tms":
                        _vm.pageVue.cartRecapComponent
                          .blockedMobileOfferToggleTms,
                      "blocked-mobile-offer-popin-tms":
                        _vm.pageVue.cartRecapComponent
                          .blockedMobileOfferPopinTms,
                      "about-blocked-mobile-offer-popin":
                        _vm.pageVue.cartRecapComponent
                          .aboutBlockedMobileOfferPopin,
                      "show-eligibility-result": false,
                      position: _vm.hashTag,
                    },
                    on: {
                      "select-mobile-offer-seo-id": function ($event) {
                        return _vm.selectVariationMobileOffer($event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("internet-and-mobile-advantages", {
            attrs: {
              "advantages-title": _vm.pageVue.advantagesTitle,
              "advantages-list": _vm.pageVue.advantagesListOfAttributes,
            },
          }),
          _vm._v(" "),
          _vm.pageVue.faq
            ? _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("showcase-faq", {
                    attrs: {
                      "faq-title": _vm.pageVue.faq.faqTitle,
                      "faq-list-of-attributes":
                        _vm.pageVue.faq.faqListOfAttributes,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("internet-and-mobile-legal-mentions", {
            attrs: {
              "legal-mentions-title": _vm.pageVue.legalMentionsTitle,
              "legal-mentions-text": _vm.pageVue.legalMentionsText,
              "hands-free-text": _vm.pageVue.handsFree,
            },
          }),
          _vm._v(" "),
          _vm.pageVue.showSnackbar
            ? _c("ob1-snack-bar", {
                ref: "technoSnackbar",
                attrs: {
                  id: "techno-snackbar",
                  icon: _vm.pageVue.snackbarComponent.snackbarIcon,
                  label: _vm.pageVue.snackbarComponent.snackbarLabel,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageVue.xdslLineIntentionPopinRecommended &&
          _vm.recommendedXdslLineIntentions
            ? _c("xdsl-line-intention-popin", {
                attrs: {
                  "dto-from-object":
                    _vm.pageVue.xdslLineIntentionPopinRecommended,
                  "xdsl-line-intentions": _vm.recommendedXdslLineIntentions,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageVue.deviceIntentionPopinRecommended &&
          _vm.recommendedDeviceIntentions
            ? _vm._l(
                _vm.recommendedDeviceIntentions,
                function (deviceIntention) {
                  return _c("device-intention-popin", {
                    key: deviceIntention.popinModal
                      ? deviceIntention.popinModal.id
                      : _vm.pageVue.deviceIntentionPopinRecommended.popinModal
                          .id,
                    attrs: {
                      title: _vm.pageVue.deviceIntentionPopinRecommended.title,
                      visual:
                        _vm.pageVue.deviceIntentionPopinRecommended.visual,
                      "text-sub":
                        _vm.pageVue.deviceIntentionPopinRecommended.textSub,
                      subsidized: _vm.recommendedMobileOffer
                        ? _vm.recommendedMobileOffer.subsidized
                        : false,
                      "text4x-cb":
                        _vm.pageVue.deviceIntentionPopinRecommended.text4xCb,
                      "enable4x-cb":
                        _vm.pageVue.deviceIntentionPopinRecommended.enable4xCb,
                      "page-title":
                        _vm.pageVue.deviceIntentionPopinRecommended.pageTitle,
                      "page-type":
                        _vm.pageVue.deviceIntentionPopinRecommended.pageType,
                      "popin-modal": deviceIntention.popinModal
                        ? deviceIntention.popinModal
                        : _vm.pageVue.deviceIntentionPopinRecommended
                            .popinModal,
                      "with-device-button-cta":
                        deviceIntention.withDeviceButtonCta,
                      "without-device-button-cta":
                        deviceIntention.withoutDeviceButtonCta,
                    },
                  })
                }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pageVue.deviceIntentionPopinRecommended &&
          _vm.pageVue.recommendedOffersComponent.packSummary.deviceIntention
            ? _c("device-intention-popin", {
                attrs: {
                  title: _vm.pageVue.deviceIntentionPopinRecommended.title,
                  visual: _vm.pageVue.deviceIntentionPopinRecommended.visual,
                  "text-sub":
                    _vm.pageVue.deviceIntentionPopinRecommended.textSub,
                  subsidized: _vm.recommendedMobileOffer
                    ? _vm.recommendedMobileOffer.subsidized
                    : false,
                  "text4x-cb":
                    _vm.pageVue.deviceIntentionPopinRecommended.text4xCb,
                  "enable4x-cb":
                    _vm.pageVue.deviceIntentionPopinRecommended.enable4xCb,
                  "page-title":
                    _vm.pageVue.deviceIntentionPopinRecommended.pageTitle,
                  "page-type":
                    _vm.pageVue.deviceIntentionPopinRecommended.pageType,
                  "popin-modal":
                    _vm.pageVue.deviceIntentionPopinRecommended.popinModal,
                  "with-device-button-cta":
                    _vm.pageVue.recommendedOffersComponent.packSummary
                      .deviceIntention.withDeviceButtonCta,
                  "without-device-button-cta":
                    _vm.pageVue.recommendedOffersComponent.packSummary
                      .deviceIntention.withoutDeviceButtonCta,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageVue.xdslLineIntentionPopin && _vm.selectedXdslLineIntentions
            ? _c("xdsl-line-intention-popin", {
                attrs: {
                  "dto-from-object": _vm.pageVue.xdslLineIntentionPopin,
                  "xdsl-line-intentions": _vm.selectedXdslLineIntentions,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageVue.deviceIntentionPopin
            ? _vm._l(
                _vm.selectedDeviceIntentionList,
                function (deviceIntention) {
                  return _c("device-intention-popin", {
                    key: deviceIntention.popinModal
                      ? deviceIntention.popinModal.id
                      : _vm.pageVue.deviceIntentionPopin.popinModal.id,
                    attrs: {
                      title: _vm.pageVue.deviceIntentionPopin.title,
                      visual: _vm.pageVue.deviceIntentionPopin.visual,
                      "text-sub": _vm.pageVue.deviceIntentionPopin.textSub,
                      subsidized: _vm.mobileOffer
                        ? _vm.mobileOffer.subsidized
                        : false,
                      "text4x-cb": _vm.pageVue.deviceIntentionPopin.text4xCb,
                      "enable4x-cb":
                        _vm.pageVue.deviceIntentionPopin.enable4xCb,
                      "page-title": _vm.pageVue.deviceIntentionPopin.pageTitle,
                      "page-type": _vm.pageVue.deviceIntentionPopin.pageType,
                      "popin-modal": deviceIntention.popinModal
                        ? deviceIntention.popinModal
                        : _vm.pageVue.deviceIntentionPopin.popinModal,
                      "with-device-button-cta":
                        deviceIntention.withDeviceButtonCta,
                      "without-device-button-cta":
                        deviceIntention.withoutDeviceButtonCta,
                    },
                  })
                }
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pageVue.deviceIntentionPopin && _vm.selectedDeviceIntention
            ? _c("device-intention-popin", {
                attrs: {
                  title: _vm.pageVue.deviceIntentionPopin.title,
                  visual: _vm.pageVue.deviceIntentionPopin.visual,
                  "text-sub": _vm.pageVue.deviceIntentionPopin.textSub,
                  subsidized: _vm.mobileOffer
                    ? _vm.mobileOffer.subsidized
                    : false,
                  "text4x-cb": _vm.pageVue.deviceIntentionPopin.text4xCb,
                  "enable4x-cb": _vm.pageVue.deviceIntentionPopin.enable4xCb,
                  "page-title": _vm.pageVue.deviceIntentionPopin.pageTitle,
                  "page-type": _vm.pageVue.deviceIntentionPopin.pageType,
                  "popin-modal": _vm.pageVue.deviceIntentionPopin.popinModal,
                  "with-device-button-cta":
                    _vm.selectedDeviceIntention.withDeviceButtonCta,
                  "without-device-button-cta":
                    _vm.selectedDeviceIntention.withoutDeviceButtonCta,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }